angular
    .module('WizApp')
    .factory('LocaleService', [
        '$http',
        '$filter',
        function ($http, $filter) {
            var route = $filter('route');

            return {
                update: function (locale) {
                    return $http.post(route('wizbii_core_set_userlocale'), { locale: locale });
                }
            };
        }
    ])
    .controller('LocaleController', [
        'LocaleService',
        function (LocaleService) {
            var vm = this;

            vm.madeachoice = false;
            vm.loading = false;
            vm.update = update;
            vm.ignore = ignore;

            function update(locale) {
                if (vm.loading) return;

                vm.loading = true;

                LocaleService
                    .update(locale)
                    .success(function (data) {
                        if (data.status === 'ok') location.reload();
                        else vm.loading = false;
                    })
                    .error(function () { vm.loading = false })
                ;
            }

            function ignore(locale) {
                if (vm.loading) return;

                vm.madeachoice = true;
                $('body').removeClass('bw'); // arghhhhhhhh buuuurk

                LocaleService.update(locale);
            }
        }
    ])
;
